document.addEventListener('DOMContentLoaded', () => {
  const mq = window.matchMedia('(min-width: 990px) and (hover: hover)');
  const menus = document.querySelectorAll('header-menu > details, .header__inline-menu details');

  menus.forEach((d) => {
    let openTimer, closeTimer;

    const openNow = () => { if (!d.hasAttribute('open')) d.setAttribute('open', ''); };
    const closeNow = () => { if (d.hasAttribute('open')) d.removeAttribute('open'); };

    d.addEventListener('mouseenter', () => {
      if (!mq.matches) return;
      clearTimeout(closeTimer);
      openTimer = setTimeout(openNow, 40);
    });

    d.addEventListener('mouseleave', () => {
      if (!mq.matches) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(closeNow, 120);
    });

    d.addEventListener('focusin', () => { if (mq.matches) openNow(); });
    d.addEventListener('focusout', () => {
      if (!mq.matches) return;
      requestAnimationFrame(() => {
        if (!d.contains(document.activeElement)) closeNow();
      });
    });
  });
});
